module.exports = __webpack_public_path__ + "img/edge_divers_avion.e646ca89.svg";